import { Chip } from "@mui/material";
import { Datagrid, DateField, EditButton, ReferenceField, ReferenceManyField, SimpleShowLayout, TextField, useRecordContext } from "react-admin";

const postRowStyle = (record/*, index*/) => ({
    backgroundColor: record.data_eseguita === "0000-00-00" && (!record?.note?.toLowerCase().includes("annulla"))  ? '#f7c436' : 'white',
});

export const ManutenzioneEseguita =  ({ source }) => {
    const record = useRecordContext()
    if(!record) return null
    if(record[source]==="0000-00-00") {
        /* if the field note contains annulla we use gray color chip */
        if(record?.note?.toLowerCase().includes("annulla")){
            return  <Chip label="Non eseguito" />
        } else {
            /*  we are in the case that the field not doesn't include annulla we
                proceed in delivering the warning */
            return <Chip label="Non ancora eseguito" color="warning"/>
        }
    } else {
        return  <DateField source='data_eseguita'/>
    }
}

export default function ImpiantiReferenceManutenzioni () {
    return (<SimpleShowLayout>
                <ReferenceManyField label="Manutenzioni" reference="manutenzioni" target="id_impianto"
                 sort = {{ field: 'data_prevista', order: 'DESC' }}>
                    <Datagrid rowStyle={postRowStyle}>
                        <ReferenceField label="Tipologia" source="id_tabella_manutenzioni" reference="tabella_manutenzioni" >
                            <TextField  source="descrizione" />
                        </ReferenceField>
                        <TextField label="ID Prodotto" source='id_prodotto' />
                        
                        <DateField source='data_prevista'/>
                        <ManutenzioneEseguita source='data_eseguita'/>
                        <TextField source='note' />
                        <EditButton label="" />
                    </Datagrid>
                </ReferenceManyField>
                
            </SimpleShowLayout>)
}